import { useEffect, useRef } from "react";

const DriverRoute = ({ driver, mapRef }) => {
  const polylinesRef = useRef([]);

  const clear = () => {
    polylinesRef.current.forEach(p => p.setMap(null));
    polylinesRef.current = [];
  };

  useEffect(() => {
    if (!mapRef.current) return;

    clear();

    if (!driver?.route?.polyline?.length || !driver.location) return;

    const poly = driver.route.polyline.map(p => ({
      lat: +p.lat,
      lng: +p.lng,
    }));

    let idx =
      typeof driver?.progress?.closestIndex === "number"
        ? driver.progress.closestIndex
        : 0;

    idx = Math.min(Math.max(idx, 0), poly.length);

    const completed = poly.slice(0, idx);
    const remaining = poly.slice(idx);

    if (completed.length > 1) {
      polylinesRef.current.push(
        new window.google.maps.Polyline({
          path: completed,
          strokeColor: "#34A853",
          strokeWeight: 4,
          map: mapRef.current,
        })
      );
    }

    if (remaining.length > 1) {
      polylinesRef.current.push(
        new window.google.maps.Polyline({
          path: remaining,
          strokeColor: "rgba(0,149,255,0.35)",
          strokeWeight: 8,
          map: mapRef.current,
        }),
        new window.google.maps.Polyline({
          path: remaining,
          strokeColor: "#0285FF",
          strokeWeight: 4,
          map: mapRef.current,
        })
      );
    }

    return clear;
    // eslint-disable-next-line
  }, [
    driver.driverId,
    driver.routeKey,
    driver.location?.lat,
    driver.location?.long,
  ]);

  return null;
};

export default DriverRoute;
